<div class="row">
  <div class="col-sm-12">
    <h5>Configurar Anuncios de la Ficha</h5>
  </div>
  <div class="col-sm-3">
    <div class="card  bg-secondary text-light">
      <div class="card-header">
        <h5 class="text-dark">Clase de Anuncio</h5>
      </div>
      <div class="card-body">
        <h5 class="card-title">Ficha General</h5>
        <p class="text-justify">
          Perfil general de todas las masajistas, seleccione las imagenes que apareceran en el perfil de la anunciante.
        </p>
        <br>
        <cite>Minimo de dias disponibles: 7 </cite>
        <cite class="mt-2">REQUERIDO PARA LOS OTROS ANUNCIOS</cite>
        <div class="text-center mt-2">
          <button (click)="nav('anuncio-general')" class="btn btn-primary">
            Gestionar
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-3">
    <div class="card  bg-secondary text-light">
      <div class="card-header">
        <h5 class="text-dark">Clase de Anuncio</h5>
      </div>
      <div class="card-body">
        <h5 class="card-title">Listados Generales</h5>
        <p class="text-justify">
          Listados generales de todas las masajistas, seleccione la imagen que apareceran en los listados generales de
          la anunciante.
        </p>
        <br>
        <cite>Minimo de dias disponibles: 7 </cite>       
        <div class="text-center mt-2">
          <button (click)="nav('listas-general')" class="btn btn-primary">
            Gestionar
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-3">
    <div class="card  bg-secondary text-light">
      <div class="card-header">
        <h5 class="text-dark">Clase de Anuncio</h5>
      </div>
      <div class="card-body">
        <h5 class="card-title">Letra Asignada</h5>
        <p class="text-justify">
          Seleccione la Ubicacion exacta de donde quiera aparecer la anunciante en cualquier listado.
        </p>
        <br>
        <cite>Minimo de dias disponibles: 7 </cite>       
        <div class="text-center mt-2">
          <button (click)="nav('anuncio-general')" class="btn btn-primary">
            Gestionar
          </button>
        </div>
      </div>
    </div>
  </div>

</div>
